export default __webpack_public_path__ + "static/media/Gloves of the Lector.0a72209f.jpg";